import { FC } from 'react';
import { useFormContext } from '../../../../../../contexts/FormContext';

import styles from './EmailCard.module.css';

type EmailCardProps = {
  responseIndex: number;
  text: string;
};

export const EmailCard: FC<EmailCardProps> = () => {
  const { emailInput } = useFormContext();

  if (!emailInput) return null;

  return (
    <div className={styles['container']}>
      <div className={styles['avatar']} />
      <div className={styles['text-container']}>
        <p className={styles['handle-container']}>
          <b>{emailInput.companyName}</b>
          <span>{`<${emailInput.companyName.replace(
            / /gm,
            '_'
          )}@email.com>`}</span>
        </p>
        <p className={styles['recipient-text']}>to Recipient</p>
        {/* <p className={styles['response-text']}>{text}</p> */}
      </div>
      {/* <CardButtons responseIndex={responseIndex} /> */}
    </div>
  );
};
